import { getLocalStorage } from "components/Helper/Helper"
import { HISTORY_LOADER_STATUS, HISTORY_TABLE_TOTAL_PAGES, LOADER_STATUS, PROFILE_INFO, RECO_HISTORY_DATA, REFRESH_TAB, SAVE_RECO_HISTORY_TABLE_PAGES, SET_DOCUMENTVIEW_CURRENT_PAGE, SET_DOCUMENTVIEW_TABLE_PAGES, VENDOR_LIST } from "./constants"
import axios from "axios"
import { Config } from '../../../Config.js';
import { toast } from "react-toastify";
import { COMMON_MSGS } from "Constant/Messages";
import { errorToastMessage, successToastMessage } from "utils/errorToast";

function errorNot(msg){
  toast.success(msg, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}
function errorNotErr(msg){
  toast.error(`${msg}`, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  });
}

export function loader(status){
    return{
        type: LOADER_STATUS,
        loaderStatus: status
    }
}
export function refresh(value){
    return{
        type: REFRESH_TAB,
        refresh: value
    }
}
export function historyLoader(status){
    return{
        type: HISTORY_LOADER_STATUS,
        loaderStatus: status
    }
}

export function historyTableTotalPages(pages){
  return {
    type: HISTORY_TABLE_TOTAL_PAGES,
    pages: pages,
  }
}
export function setDocumentViewTablePages(pages){
  return {
    type: SET_DOCUMENTVIEW_TABLE_PAGES,
    pages: pages,
  }
}
export function setDocumentViewPageNumber(pageNumber){
  return {
    type: SET_DOCUMENTVIEW_CURRENT_PAGE,
    pageNumber: pageNumber,
  }
}

export function saveVendorListData(data){
    return{
        type:VENDOR_LIST,
        vendorList: data
    }
}
export function saveRecoHistoryData(data){
    return{
        type:RECO_HISTORY_DATA,
        data: data
    }
}

export function profileInfo(payload){
  return{
    type: PROFILE_INFO,
    profileData: payload
  }
}

export const getProfile = (value) => {
  return (dispatch) => {
    dispatch(loader(true))
    let data = {
      profileId: value
    }
    return new Promise((resolve, reject) => {
       axios({
        method: 'post',
        url: `${Config.url}gst/get_profile`,
        data: data,
        headers: {
          token: (getLocalStorage('loginDetails')),
        },
      })
        .then(response => {
          // console.log('response ', response.data.profileInfo);
          if(response.data.error != 1){
            dispatch(profileInfo(response.data.profileInfo))
          }
        
           dispatch(loader(false))
          resolve(true);
        })
        .catch(error => {
          dispatch(loader(false))
          console.log(error);
          reject(true)
  
        });
    });
  }
}

export const getVendorListData = (data) => {
    return (dispatch) => {
      dispatch(loader(true))
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/getVendorMasterEmailList`,
          data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response.data.data);
            let modifiedData = response?.data?.data?.map(item=> {
              return {
                ...item,
                listKey:`${item.gstin}~${item.email}`
              }
            })
            dispatch(saveVendorListData(modifiedData));
            dispatch(loader(false))
            resolve(modifiedData);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
export const getRelatedInvoices = (data, selectedGstin, selectedPeriod, forceStrSearch) => {
    return (dispatch) => {
      dispatch(loader(true))
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/validateDocumentNumber`,
          data:{data, selectedGstin, selectedPeriod, forceStrSearch},
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            if(response.data.error == 0){
              resolve(response.data.data);
            } else {
              resolve([]);
            }
            dispatch(loader(false))
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            resolve([])
    
          });
      });
    }
}

export function saveRecoHistoryDataPageCount(pages){
  return {
    type: SAVE_RECO_HISTORY_TABLE_PAGES,
    pages: pages
  }
}
export const getReconcileHistoryData = (pageNumber, limit) => {
  let data = {pageNumber, limit};
    return (dispatch) => {
      dispatch(loader(true))
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/getReconciliationHistory`,
          data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
          if(response.data.error != 1){
            dispatch(saveRecoHistoryData(response.data.data));
            dispatch(saveRecoHistoryDataPageCount(Math.ceil(response.data.totalRecord/limit)));
            errorNot(response.data.message);
            resolve(response.data.data);
          }
          else{
              dispatch(saveRecoHistoryData([]));
              errorNotErr(response.data.message);
              resolve([]);
          }
          dispatch(loader(false));
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
export const getDataFetchTableData = (gstin, ret_period, fiscal_year) => {
    let data = {gstin, ret_period, fiscal_year, type:"gstr_6a"} 
    return (dispatch) => {
      dispatch(loader(true))
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/fetchGSTR6AData`,
          data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
          if(response.data.error != 1){
            // dispatch(saveRecoHistoryData(response.data.data));
            errorNot(response.data.msg);
            resolve(response.data.data);
          }
          else{
              // dispatch(saveRecoHistoryData([]));
              errorNotErr(response.data.msg);
              resolve([]);
          }
          dispatch(loader(false));
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
export const getAggregatedTableData = (gstin, ret_period, fiscal_year, entity) => {
    let data = {gstin, ret_period, fiscal_year, entity, type:"gstr_6a"} 
    return (dispatch) => {
      dispatch(loader(true))
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/getGSTR6AFetchData`,
          data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
          if(response.data.error != 1){
            // dispatch(saveRecoHistoryData(response.data.data));
            // errorNot(response.data.msg);
            resolve(response.data.data);
          }
          else{
              // dispatch(saveRecoHistoryData([]));
              // errorNotErr(response.data.msg);
              resolve([]);
          }
          dispatch(loader(false));
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }

export const getHistoryData = (pageNumber, limit) => { 
  let data = {pageNumber, limit}
    return (dispatch) => {
      dispatch(historyLoader(true))
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/fetchGSTR6AHistoryData`,
          data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
          if(response.data.error != 1){
            // dispatch(saveRecoHistoryData(response.data.data));
            dispatch(historyTableTotalPages(Math.ceil(response.data.totalRecord/limit)));
            errorNot(response.data.message);
            resolve(response.data.data);
          }
          else{
              // dispatch(saveRecoHistoryData([]));
              dispatch(historyTableTotalPages(1));
              errorNotErr(response.data.message);
              resolve([]);
          }
          dispatch(historyLoader(false));
          })
          .catch(error => {
            dispatch(historyLoader(false));
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
export const reconcileHistoryPipeline = (batch_id) => {
  let data = {batch_id};
    return (dispatch) => {
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          data:data,
          url: `${Config.url}gstR6/getRecoPipleLineStatus`,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
          resolve(true);
          })
          .catch(error => {
            console.log(error);
            reject(true)
    
          });
      });
    }
  }

  export const sendEmailToVendors = (data) => {
    return (dispatch) => {
      dispatch(loader(true));
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/sendEmailReconciliationReport`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            dispatch(loader(false))
            resolve(response);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }

  export const reconcileData = (gstin, purchaseRegisterPeriod, gstr6aPeriod, value, tolerance) => {
    return (dispatch) => {
      dispatch(loader(true))
      let data = {
        gstin,
        purchaseRegisterPeriod,
        gstr6aPeriod,
        value,
        tolerance
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/performGSTR6Reconcilation`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              dispatch(profileInfo(response.data.profileInfo))
            }
            else {
              errorToastMessage(response.data.message);
            }
            dispatch(loader(false))
            resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
  export const getRecoTabTableData = (gstin, ret_period, viewType) => {
    return (dispatch) => {
      dispatch(loader(true))
      let data = {
        gstin, 
        ret_period, 
        viewType : (viewType=="1")?"summary":"documentView",
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/viewGSTR6Reconciliation`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              resolve(response.data.data);
            }
          
            dispatch(loader(false))
            resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
  export const fetchDocumentViewData = (pageNumber, pageLimit, gstin, ret_period, DocTypeArr, OriginalMatchTypeArr, RevisedMatchTypeArr, str, activeTab, isSubmit) => {
    return (dispatch) => {
      dispatch(loader(true))
      if(isSubmit){
        dispatch(refresh(false));
      }
      let data = {
        gstin, 
        ret_period,
        docType: DocTypeArr, 
        originalMatchType: OriginalMatchTypeArr, 
        revisedMatchType: RevisedMatchTypeArr,
        str,
        viewType: "DocumentView",
        pageNumber, 
        pageLimit
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/viewGSTR6Reconciliation`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              dispatch(setDocumentViewTablePages(Math.ceil(response.data.totalRecords/pageLimit)));
              resolve(response.data.data.documentData);
            }else{
              resolve([]);
            }
          
            dispatch(loader(false))
            if(isSubmit){
              dispatch(refresh(true));
            }
            resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
  export const fetchActionData = (gstin, ret_period, DocTypeArr, OriginalMatchTypeArr, RevisedMatchTypeArr, str, activeTab, isSubmit) => {
    return (dispatch) => {
      dispatch(loader(true))
      if(isSubmit){
        dispatch(refresh(false));
      }
      let data = {
        gstin, 
        ret_period,
        docType: DocTypeArr, 
        originalMatchType: OriginalMatchTypeArr, 
        revisedMatchType: RevisedMatchTypeArr,
        str,
        viewType: "DocumentView"
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/viewGSTR6Reconciliation`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              resolve(response.data.data.actionData);
            }
            else{
              resolve([]);
            }
            if(isSubmit){
              dispatch(refresh(true));
            }
            dispatch(loader(false))
            resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
  export function getRejectedRecordsData(gstin, ret_period, docType, originalMatchType, revisedMatchType, searchValue) {
    return (dispatch) => {
      dispatch(loader(true))
      let data = {
        gstin, ret_period, docType, originalMatchType, revisedMatchType, searchValue, batch_id: ""
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/viewRejectedRecords`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              resolve(response.data.data);
            }
            else{
              resolve([]);
            }
          
            dispatch(loader(false))
            // resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
  export const fetchSummaryData = (gstin, ret_period, activeTab) => {
    return (dispatch) => {
      dispatch(loader(true))
      let data = {
        gstin, 
        ret_period,
        viewType:"summary"
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/viewGSTR6Reconciliation`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              resolve(response.data.data.summaryData);
            }else{
              resolve([]);
            }
          
            dispatch(loader(false))
            resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
  export const forceMatchRecords = (gstin, ret_period, tableData, inumSearch, dataType) => {
    return (dispatch) => {
      dispatch(loader(true))
      let data = {
        gstin, ret_period, tableData, inumSearch, dataType, action: "FORCE MATCH"
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/performForceMatch`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              // resolve(response.data.data.summaryData);
              errorNot(response.data.message);
            }else{
              errorNotErr(response.data.message);
            }
            resolve(true);
          
            dispatch(loader(false))
            resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
  export const restoreRejectedRecords = (selectedGstin, selectedPeriod, selectedDocType, originalMatchType, revisedMatchType, searchStr, inumPurchaseArray, inumSalesArray, statusValue="Pending") => {
    return (dispatch) => {
      dispatch(loader(true))
      let data = {
        selectedGstin, selectedPeriod, selectedDocType, originalMatchType, revisedMatchType, searchStr, inumPurchaseArray, inumSalesArray, statusValue
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/restoreRejectedRecords`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              // resolve(response.data.data.summaryData);
              errorNot(response.data.message);
            }else{
              errorNotErr(response.data.message);
            }
            resolve(true);
          
            dispatch(loader(false))
            resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }
  export const unforceMatchRecords = (gstin, ret_period, tableData, inumSearch, dataType) => {
    return (dispatch) => {
      dispatch(loader(true))
      let data = {
        gstin, ret_period, tableData, inumSearch, dataType, action: ""
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/performForceMatch`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              // resolve(response.data.data.summaryData);
              errorNot(response.data.message);
            }else{
              errorNotErr(response.data.message);
            }
            resolve(true);
          
            dispatch(loader(false))
            resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }

  export const download6AData = (entity, gstin, ret_period, selected, selectedReturnPeriod) => {
    return (dispatch) => {
      let data = {
        entity, gstin, ret_period, selected, selectedReturnPeriod
      };
      dispatch(loader(true));
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: `${Config.url}gstR6/downloadGSTR6AFetchData`,
          headers: {
            token: getLocalStorage("loginDetails"),
          },
          data: data,
          responseType: "blob",
        })
          .then(async (response) => {
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            
              link.setAttribute("download", "GSTR6AData.xlsx");
            
            document.body.appendChild(link);
            link.click();
            successToastMessage(COMMON_MSGS.DATA_DOWNLOADED);
            dispatch(loader(false));
            resolve(true);
          })
          .catch((error) => {
            reject(true);
          });
      });
    };
  };
  export const downloadRecoHistoryData = (gstin, ret_period, batch_id) => {
    return (dispatch) => {
      let data = {
        gstin, ret_period, batch_id
      };
      dispatch(loader(true));
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: `${Config.url}gstR6/downloadReconciliationReport`,
          headers: {
            token: getLocalStorage("loginDetails"),
          },
          data: data,
          responseType: "arraybuffer",
        })
          .then(async (response) => {
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            
              link.setAttribute("download", "GSTR6ReconcilationReport.xlsx");
            
            document.body.appendChild(link);
            link.click();
            dispatch(loader(false));
            resolve(true);
          })
          .catch((error) => {
            reject(true);
          });
      });
    };
  };

  export const handleActionChange = (selectedGstin, selectedPeriod, selectedDocType, originalMatchType, revisedMatchType, searchStr, statusValue, inumPurchaseArray, inumSalesArray) => {
    return (dispatch) => {
      dispatch(loader(true))
      let data = {
        selectedGstin, selectedPeriod, selectedDocType, originalMatchType, revisedMatchType, searchStr, statusValue, inumPurchaseArray, inumSalesArray
      }
      return new Promise((resolve, reject) => {
         axios({
          method: 'post',
          url: `${Config.url}gstR6/actionOnReconciliationData`,
          data: data,
          headers: {
            token: (getLocalStorage('loginDetails')),
          },
        })
          .then(response => {
            console.log('response ', response);
            if(response.data.error != 1){
              // resolve(response.data.data.summaryData);
              errorNot(response.data.message);
            }else{
              errorNotErr(response.data.message);
            }
            resolve(true);
          
            dispatch(loader(false))
            // resolve(true);
          })
          .catch(error => {
            dispatch(loader(false))
            console.log(error);
            reject(true)
    
          });
      });
    }
  }